import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ImpersonationBannerComponent } from '../../../shared/components/impersonation-banner/impersonation-banner.component';

@Component({
    selector: 'au-landing-layout',
    templateUrl: './landing-layout.component.html',
    styleUrls: ['./landing-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ImpersonationBannerComponent, RouterOutlet]
})
export class LandingLayoutComponent implements OnInit, OnDestroy {
  mercuryLogoPath = '../../assets/images/mercury-logo-original.svg';
  isometricGridPath = '../../assets/images/isometric-grid.svg';
  title?: string = 'Tell us about your Company';
  titleFinal: string = 'Thank you for choosing Mercury';
  private routeSub$: Subscription | undefined = undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.routeSub$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((_events) => {
        if (
          this.router.routerState.snapshot.url.toString() ===
          '/onboarding/final'
        ) {
          this.title = this.titleFinal;
        }
      });
  }

  ngOnDestroy() {
    this.routeSub$?.unsubscribe();
  }
}
